import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import assetUrl from 'src/utils/assetUrl'

import { handleTransitionEnd } from './useScrollMagic'

import Link   from './Link'
import Panel  from './Panel'

import HomePanel        from './HomePanel'
import ProjectsPanel    from './ProjectsPanel'
import InitiativePanel  from './InitiativePanel'
import NonprofitPanel   from './NonprofitPanel'
import DonatePanel      from './DonatePanel'

import ImpactWidget from './ImpactWidget'
import MapContent   from './MapContent'

const pledgelingLogo = assetUrl(RAILS_ASSET_URL('/logo-white.svg'))

const Content = ({ title, charity, ...props }) => {
  const currentProject =
    props.projects.find(project => project.featured) || props.projects[0]

  const [ loaded, setLoaded ] = useState(false)

  useEffect(() => {
    if (document.readyState == 'complete')
      setLoaded(true)
    else
      addEventListener('load', () => setLoaded(true))
  }, [])

  return (
    <div
      className={[
        props.showNav       ? 'nav-drawer-open'         : '',
        props.showContent   ? 'content-drawer-open'     : '',
        props.projectPanel  ? 'projects-panel-selected' : '',
        props.activeMarker  ? 'map-marker-selected'     : '',
      ].filter(Boolean).join(' ')}
      onClick={props.handleMapMarkerBlur}
    >

      <div className={`loading-overlay ${loaded ? 'loading-loaded' : ''}`}>
        <div className="loading-message rounded-pill shadow" role="status">
          <div className="loading-icon d-inline-block text-primary">
            <div className="loading-icon-loading spinner-border"></div>
            <span className="loading-icon-loaded">
              <FontAwesomeIcon icon="check" size="2x" />
            </span>
          </div>
          <div className="loading-text h4 text-uppercase d-inline-block ml-3 my-0">
            {loaded ? 'Loaded' : 'Loading...'}
          </div>
        </div>
      </div>

      <div
        className="nav-drawer-overlay"
        onClick={() => props.setShowNav(false)}
      />

      <div className="nav-drawer fixed-top bg-primary">
        <div className="navbar-light">
          <button
            type="button"
            className="navbar-toggler d-inline-block"
            onClick={() => props.setShowNav(showNav => !showNav)}
          >
            <span className="navbar-toggler-icon"></span>
            <span className="sr-only">Toggle Navigation</span>
          </button>
        </div>

        <div className="nav-drawer-inner">
          <nav className="navbar navbar-expand navbar-dark bg-primary text-uppercase small font-weight-bold flex-column p-0">
            <Link
              className="navbar-brand"
              href="#home"
              current={props.panel}
              onClick={href => props.openPanel(href, false)}
            >
              <span className="sr-only">{title}</span>
            </Link>

            <ul className="navbar-nav mb-auto flex-column">
              <li className="nav-item">
                <Link
                  className="nav-link"
                  href="#home"
                  current={props.panel}
                  onClick={props.openPanel}
                >
                  Featured Rebuild
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  href="#projects"
                  current={props.panel}
                  onClick={props.openPanel}
                >
                  Rebuilds
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  href="#initiative"
                  current={props.panel}
                  onClick={props.openPanel}
                >
                  About<br /> {title}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  href="#nonprofit"
                  current={props.panel}
                  onClick={props.openPanel}
                >
                  About {charity.name}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  href="#donate"
                  current={props.panel}
                  onClick={props.openPanel}
                >
                  Donate
                </Link>
              </li>
            </ul>

            <div className="text-center text-white powered-by">
              <small className="d-block pb-2">Powered by </small>
              <img
                src={pledgelingLogo}
                alt="Pledge"
              />
            </div>
          </nav>
        </div>
      </div>

      <div className="content-drawer-header">
        <Link
          href="#projects"
          className="projects-back d-inline-block p-3 ml-5 ml-md-0"
          onClick={() => props.setProjectPanel(null)}
        >
          <FontAwesomeIcon icon="angle-left" className="mr-2" />
          Back
        </Link>

        <button
          type="button"
          className="close content-drawer-close"
          aria-label="Close"
          disabled={!props.showContent}
          onClick={() => props.setShowContent(false)}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div className="content-drawer-overlay bg-white position-fixed d-lg-none">
      </div>

      <div
        className="content-drawer bg-white"
        onTransitionEnd={handleTransitionEnd}
      >
        <Panel
          id="home"
          current={props.panel}
          showContent={props.showContent}
        >
          <HomePanel
            project={currentProject}
            title={title}
            charity={charity}
          />
        </Panel>

        <Panel
          id="projects"
          current={props.panel}
          showContent={props.showContent}
        >
          <ProjectsPanel
            projects={props.projects}
            projectPanel={props.projectPanel}
            setProjectPanel={props.setProjectPanel}
          />
        </Panel>

        <Panel
          id="initiative"
          current={props.panel}
          showContent={props.showContent}
        >
          <InitiativePanel title={title} />
        </Panel>

        <Panel
          id="nonprofit"
          current={props.panel}
          showContent={props.showContent}
        >
          <NonprofitPanel charity={charity} />
        </Panel>

        <Panel
          id="donate"
          current={props.panel}
          showContent={props.showContent}
        >
          <DonatePanel widgets={props.widgets} />
        </Panel>
      </div>

      <div className="map-area d-flex flex-column">
        <MapContent
          title={title}
          projects={props.projects}
          projectPanel={props.projectPanel}
          openProjectPanel={props.openProjectPanel}
          activeMarker={props.activeMarker}
          setActiveMarker={props.setActiveMarker}
          setShowNav={props.setShowNav}
        />

        <div className="impact-widgets text-white bg-dark">
          <ImpactWidget {...props.impact} />
        </div>
      </div>
    </div>
  )
}

export default Content
